import React, { useEffect, useState } from 'react'
import TableWrapper from '../../../../component/TableWrapper';
import { Icons, Images } from '../../../../assets';
import { useNavigate } from 'react-router-dom';
import NormalSelect from '../../../../component/NormalSelect';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { Toast } from '../../../../service/toast';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
import { useDispatch } from 'react-redux';
import { getFormat } from '../../../../helpers';
import GetUserPermission from '../../../../component/GetUserPermission';

const ResourcesTableList = (props) => {

    const { setPage, productList, isLoading, sortConfig, setSortConfig, handleDelete, getProductList } = props
    const ACTIVE = 'Active'
    const IN_ACTIVE = 'Inactive'
    const dropdownList = [
        { label: ACTIVE, value: true },
        { label: IN_ACTIVE, value: false },
    ]
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const viewPermission = GetUserPermission({ key: 'view' });
    const deletePermission = GetUserPermission({ key: 'delete' });
    const editPermission = GetUserPermission({ key: 'edit' });

    const userHeader = [
        { label: 'Title', sortable: "title" },
        { label: 'Product Category' },
        { label: 'Status' },
        { label: 'Actions' },
    ];


    const handleStatus = async (id, value) => {
        dispatch(saveLoadingState(true))
        let url = `${Exported.Endpoints.getResourcesByID}/${id}`

        const requestData = {
            status: value,
        }
        await request({
            url: url,
            method: Exported.APIMethods.PUT,
            data: requestData
        }).then(async (res) => {
            if (res?.data?.status) {
                await getProductList()
                Toast({
                    type: 'success',
                    message: 'Status updated successfully'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        dispatch(saveLoadingState(false))
    }

    const handleTitle = (keyValue, imgFormat, mimetype, className = '') => {
        return (
            <td className={`${className}`}>
                <div className='w-[100%] flex items-center'>
                    <div className='w-[30px] h-[30px]'>
                        <img src={getFormat(imgFormat)} alt={mimetype} className='w-[100%] h-[100%]' style={{ objectFit: 'contain' }} />
                    </div>
                    <div className='ml-2 w-[100%] ellipses-text' title={keyValue}>{keyValue}</div>
                </div>
            </td>
        )
    };

    const handleData = (keyValue, defaultValue, className = '') => {
        return (
            <td className={`${className}`}>{keyValue ? keyValue : defaultValue}</td>
        )
    };

    const redirectTo = (index) => {
        navigate(`?id=${index}`)
    }
    return (
        <>
            <div className={`eventWrapper`}>
                <div className={`mt-2 mb-5`}>
                    <TableWrapper
                        headerDetails={userHeader}
                        pageMeta={productList?.pageMeta}
                        handlePageChange={setPage}
                        listLength={productList?.result || []}
                        isLoading={isLoading}
                        sortConfig={sortConfig}
                        setSortConfig={setSortConfig}
                    >
                        {productList?.result?.map((item, index) => {
                            const { title = '', media_file = '', mimetype = '', category = {}, status = '', id = '' } = item;
                            return (
                                <tr key={title}>
                                    {handleTitle(title, media_file, mimetype)}
                                    {handleData(category?.title, '-', 'text-center')}
                                    <td className=" px-3 mx-auto text-center w-[130px]">
                                        <div className=' '>
                                            <NormalSelect
                                                className={`w-[100%] p-0`}
                                                list={dropdownList}
                                                value={status ? ACTIVE : IN_ACTIVE}
                                                handleChange={(e) => e !== status ? handleStatus(id, e) : null}
                                                highLight
                                                highLightColor={
                                                    status ? "#01CB46" :
                                                        "#FC0000"
                                                }
                                                placeholder="Status"
                                            />
                                        </div>
                                    </td>
                                    <td className=" px-3 mx-auto text-center action-button">
                                        <div className='flex items-center justify-center'>
                                            <img src={Icons.eye} alt='View' className='cursor-pointer w-[20px] h-[20px]' onClick={() => redirectTo(id)} />
                                            {/* <img src={Icons.downloadIcon} alt='Download' className='cursor-pointer w-[20px] h-[20px] ml-2' /> */}
                                            {deletePermission ?
                                                <img src={Icons.delete} alt='Delete' className='cursor-pointer w-[20px] h-[20px] mx-2' onClick={() => handleDelete(id)} />
                                                : null}
                                            {editPermission ?
                                                <img src={Icons.edit} alt='Edit' className='cursor-pointer w-[18px] h-[18px]' onClick={() => navigate(`?type=edit?id=${id}`)} />
                                                : null}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </TableWrapper>
                </div>
            </div>
        </>
    )
}

export default ResourcesTableList